import React, { FC, memo, useMemo } from 'react'
import { Button, IButtonProps } from '@wmgtech/legato'
import { useLocalProjectFlags, useProjectParent } from 'modulesCommon/serviceHooks'
import { useNavigate } from 'react-router-dom'
import { Can } from 'shared/abilities'
import { activeProjectVar } from 'modulesCommon/store'
import { useGlobalize } from 'modules/Globalize/graphql/mutations/globalizeProject'
import { useReactiveVar } from '@apollo/client'
import { subject } from '@casl/ability'
import { IProject } from 'shared/interfaces'

const buttonCommonProps: Partial<IButtonProps> & Record<string, any> = {
  colorType: 'secondary-black',
  containerStyle: 'outline',
  size: 'md',
  'data-edit-mode': true
}

export const GlobalizeButton: FC = memo(() => {
  const navigate = useNavigate()
  const p = useReactiveVar<IProject>(activeProjectVar)
  const { mutate: globalizeProject, loading } = useGlobalize()
  const project = useMemo(() => subject('Project', { ...p }), [p])
  const { isGlobalized, isGlobalizing } = useLocalProjectFlags(project)
  const globalProject = useProjectParent(project)

  if (isGlobalized) {
    return (
      <Can I={'access'} a={'GlobalHub'}>
        <Button
          {...buttonCommonProps}
          label="View Global Project"
          secondaryIcon="arrow-up-right-from-square"
          onClick={() => navigate(`/globalhub/projects/${globalProject?.id}`)}
        />
      </Can>
    )
  } else if (isGlobalizing) {
    return (
      <Can I={'globalize'} this={project}>
        <Button
          {...buttonCommonProps}
          label="Continue Globalizing"
          onClick={() => navigate(`/globalhub/projects/new/${globalProject?.id}`)}
        />
      </Can>
    )
  } else {
    return (
      <Can I={'globalize'} this={project}>
        <Button
          {...buttonCommonProps}
          label={loading ? 'Globalizing...' : 'Globalize Project'}
          disabled={loading}
          onClick={() => {
            globalizeProject({ variables: { id: project.id } })
              .then(({ data: { globalizeCampaign } }) => {
                if (globalizeCampaign?.id) {
                  navigate(`/globalhub/projects/new/${globalizeCampaign.id}`)
                }
              })
              .catch((e) => {
                console.error(e)
              })
          }}
        />
      </Can>
    )
  }
})
